/*globals EB,EBG*/
var EventEmitter = require('event-emitter');

function Sizmek(config) {
	console.log('[new Sizmek]');
	if (config) window.addEventListener('load', this.initEB.bind(this));

	this.event = new EventEmitter();
	this.config;
}

Sizmek.prototype.initEB = function() {
	if (!EB.isInitialized()) {
		EB.addEventListener(EBG.EventName.EB_INITIALIZED, this.startAd.bind(this));
	} else {
		this.startAd();
	}
};

Sizmek.prototype.startAd = function() {

	console.log('   >szk> startAd ');

	//if (this.config.expand) EB.initExpansionParams(0, 0, this.config.expand.width, this.config.expand.height);
	//WARNING : Suupprimer dans le doute
	//EB.initExpansionParams(0, 0, 666, 666);

	//EB._sendMessage('resizecontainer', {width:'full',height:'full',x:'pageLeft', y:0, pushDown:true});
	//EB._sendMessage('resizecontainer', {width:320, height:50, x:0, y:0,pushDown:true});

	if (this.config && this.config.pushdownSettings) EB._sendMessage('resizecontainer', this.config.pushdownSettings);

	//desactiver pour implementer notre propre système
	//this.setUpAutoExpandFrequencyCapping();
	console.log('   [event] Sizmek::INIT_AD ');
	this.event.emit('INIT_AD', this);
};

Sizmek.prototype.getCustomJSVar = function(varName, defaultValue) {
	if (typeof defaultValue === 'undefined') defaultValue = null;

	try {
		if (typeof EB._adConfig.customJSVars !== 'undefined' && EB._adConfig.customJSVars.hasOwnProperty(varName)) {
			if (typeof EB._adConfig.customJSVars[varName] === 'undefined') {
				return defaultValue;
			} else if (typeof EB._adConfig.customJSVars[varName] === 'string') {
				return EB._adConfig.customJSVars[varName].toString().replace(/&quot;/g, '"');
			} else {
				return EB._adConfig.customJSVars[varName];
			}
		} else {
			return defaultValue;
		}
	} catch (error) {
		return defaultValue;
	}
};

/*this.setUpAutoExpandFrequencyCapping = function() {

	var expandConfig = {
		frequencyCappingEnabled: this.getCustomJSVar('mdFrequencyCappingEnabled', true),
		frequencyCappingLimit: this.getCustomJSVar('mdFrequencyCappingLimit', 1)
	};

	//frequency: EB.autoExpandFrequencyCapping.Frequencies.NEVER,
	//expansionsPerPeriod: 0,
	var autoExpandSettings = {
		isEnabled: true,
		frequency: EB.autoExpandFrequencyCapping.Frequencies.CAMPAIGN,
		expansionsPerPeriod: expandConfig.frequencyCappingLimit,
		timeUntilAutoCollapse: 0
	};

	console.log('------> autoExpandSettings', autoExpandSettings);

	var beforeAutoExpandSubscription = new EB.autoExpandFrequencyCapping.EventSubscription({
		eventName: EB.autoExpandFrequencyCapping.Events.AUTO_EXPAND,
		callback: function() {
			this.event.emit('EXPAND_AD', this);
		},
		callbackBinding: this,
		timing: EB.autoExpandFrequencyCapping.EventTiming.BEFORE
	});
	var afterAutoCollapseSubscription = new EB.autoExpandFrequencyCapping.EventSubscription({
		eventName: EB.autoExpandFrequencyCapping.Events.AUTO_COLLAPSE,
		callback: function() {
			this.event.emit('COLLAPSE_AD', this);
		},
		callbackBinding: this,
		timing: EB.autoExpandFrequencyCapping.EventTiming.AFTER
	});

	EB.autoExpandFrequencyCapping.subscribeToEvent(beforeAutoExpandSubscription);
	EB.autoExpandFrequencyCapping.subscribeToEvent(afterAutoCollapseSubscription);
	EB.autoExpandFrequencyCapping.initialize(autoExpandSettings);
};*/

Sizmek.prototype.expand = function(ebParam) {
	EB.expand(ebParam);
};

Sizmek.prototype.collapse = function(ebParam) {
	EB.collapse(ebParam);
};

Sizmek.prototype.initVideo = function(video) {
	console.log('   >szk> initVideo : #' + video.id);
	new EBG.VideoModule(video);
};

Sizmek.prototype.checkSameUid = function(uid) {
	if (EB._isLocalMode) {
		return true;
	} else {
		return uid === EB._adConfig.uid;
	}
};

module.exports = Sizmek;
